module.exports = __webpack_public_path__ + "static/media/20240530075802_IMG_7392-min.cc835b42.JPG";